import { imgURL } from '@/config/index'
import test from '@/z/callback/test'
export default function imgsrc(src) {
  if (test.url(src)) {
    return src
  } else {
    return `${imgURL}${src}`
  }
}
